<template>
  <div class="wy-smart-tag-dashboard-table">
    <wy-page-modal ref="pageModal">
      <wy-smart-tag-dashboard-table-detail ref="detailPage" :parent="module" :selectedItem="selectedItem" :clickEvent="clickEvent" />
    </wy-page-modal>

    <wy-smart-tag-dashboard-table-page-header ref="header" :controller="module" :tableRef="module.$refs.table"/>
    <wy-table-list ref="table" :controller="module" :enableSelection="true" :editPermission="4601" :rowClickEvent="handleRowClick" :defaultSort="{name: 'totalVolumeDMValue', type: 1}" :searchFieldName="searchFields" :searchOrFilter="true"/>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import WyTableList from '../widgets/wy-table-list';
import WyInteractionsContactReasonsHeader from './wy-smart-tag-dashboard-table-page-header'
import WyInteractionsContactReasonsDetail from './wy-smart-tag-dashboard-table-page-detail';
import WyPageModal from '../widgets/wy-page-modal';

export default Vue.extend({
  name: 'wy-smart-tag-dashboard-table',
  components: { 
    'wy-page-modal': WyPageModal,
    'wy-table-list': WyTableList,
    'wy-smart-tag-dashboard-table-page-header': WyInteractionsContactReasonsHeader,
    'wy-smart-tag-dashboard-table-detail': WyInteractionsContactReasonsDetail,
  },
  
  data() {
    return {
      module: this,
      selectedItem: null,
      searchFields: 'smartTagName',
      clickEvent: null,
      columns: [
        {label: "", type:"selection", name: "index", selected: true, sortable: false, mandatory: true, group: 'Selection', minWidth: 30, align:"center", fixed: true},
        {label: "AI Tag Name", searchHighlight: true, name: "smartTagName", mandatory: true, selected: false, sortable: true, group: ' ', align:"left", minWidth: 350, fixed: true, copyable: false, isEditTopicName: false, extendableField: true, dataTestId: 'AiTags-AiGeneratedTags-AiTagName', toolTips: true},
        {label: "AI Tag Category", searchHighlight: true, name: "smartTagCategory", mandatory: true, selected: false, sortable: true, group: '', align:"left", minWidth: 180, fixed: true, copyable: false, isEditTopicName: false, extendableField: true, toolTips: true},

        {label: "Total", name: "totalVolumeDMValue", selected: true, sortable: true, sortBy: 'totalVolumeDMValue', group: 'Volume', minWidth: 100, align:"right"},
        {label: "Trend", type: "html", name: "trendGraph", selected: true, sortable: false, group: 'Volume', minWidth: 180},
        {label: "% of total", name: "volumePercent", selected: true, sortable: true, group: 'Volume', sortBy: 'volumePercentNum', minWidth: 120, suffix: "%", align:"right"},
        {label: "% change", type: "percentChange", name: "volumeChangeDisplay", selected: true, sortable: true, sortBy: 'volumeChangeWithoutAbs', group: 'Volume', minWidth: 150, suffix: "%", tooltipMessage: "volumeChangeTooltip", compareWith: 'totalVolumeCompare', noDataSortable: true},

        {label: "Average", name: "avgAgentHandleTimeDisplay", type: 'singleSelect', selected: true, sortable: true, sortBy: 'avgAgentHandleTime', group: 'Call Handle Time', minWidth: 140},
        {label: "% change", type: "percentChange", name: "avgAgentHandleTimeChangeDisplay", selected: true, sortable: true, sortBy: 'avgAgentHandleTimeChangeWithoutAbs', group: 'Call Handle Time', parent: "avgAgentHandleTimeDisplay", minWidth: 150, suffix: "%", tooltipMessage: "avgAgentHandleTimeChangeTooltip", compareWith: 'avgAgentHandleTimeCompareDisplay', noDataSortable: true},
      ],
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'companyConfig', 'tableModel', 'config', 'dateCompareRange']),
  },

  methods: {
    ...mapMutations(['addDataModelSortings', 'updateDataModelColumns', 'updateDataModelFilter']),
    ...mapActions(['fetchSmartTagsDashboard']),

    refreshTable() {
      this.$refs.table.refreshTable();
    },

    async refreshData() {      
      await this.handleFilterChange({forceRefresh: true, logEvent: false});
      this.$refs.table.refreshTable();      
    },

    async handleFilterChange(options) {
      this.$root.$emit(`fire-global-filter-change-events`, options);
      if((!this.$router.app.isLoading() && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
        this.$router.app.setLoading(true);
        let isOK = await this.fetchSmartTagsDashboard(options);        
        if(this.$refs.table) {
          if(isOK) {
            this.$refs.table.refreshTable();

            // Simulating opening & closing the column selection dropdown, in order to refresh the
            // table so that "% Change" columns hide/show in response to hide/show of "containment" 
            // and "handoffs" column as a result of global filter changes (i.e. "virtual agent 
            // contained", "both virtual & live agents", "live agent only" global filters)
            // if(this.$refs.header.$refs.columnSelectionDropdown) {
            //   this.$refs.header.$refs.columnSelectionDropdown.handleVisibleChange(true);
            //   this.$refs.header.$refs.columnSelectionDropdown.handleVisibleChange(false);
            // }

            let findItem = null;
            if(this.selectedItem && this.tableModel.results && this.tableModel.results.length > 0) {
              this.tableModel.results.forEach(item => {
                if(item.smartTagUniqueKey == this.selectedItem.smartTagUniqueKey) {
                  findItem = item;                
                }
              });
            }
            
            if(this.$refs.detailPage) {
              this.$refs.detailPage.refreshUI(findItem);
            }
            else {
              // this.loading = false;
            }
          }
        }        
        else {
          this.$router.app.setLoading(false);
        }
      }
    },

    async refreshTableData() {
      if(!this.$router.app.isLoading()) {
        this.$router.app.setLoading(true);
        this.$refs.table.clearSelection();
        await this.fetchSmartTagsDashboard({forceRefresh: true});
        if(this.$refs.table) {          
          this.$refs.table.refreshTable();
        }        
        this.$router.app.setLoading(false);
      }
    },

    handleRowClick(rowIndex, item) {
      this.selectedItem = item;
      this.$root.$el.classList.add("smartTagDashboardDetail");
      this.$refs.table.$el.style.display = "none"
      this.$refs.pageModal.open();      
    },

    refreshPage() {
      this.refreshTableData();
    }
  },

  async created() {
    this.$router.currPageComponent = this;

    // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]({filterName: event.type});
    })

    // table config
    if(this.config.table != null) {
      let hideColumns = this.config.table.hideColumns;
      if(hideColumns != null && Array.isArray(this.config.table.hideColumns)) {
        this.columns = this.columns.filter(el => !hideColumns.includes(el.group));
      }
    }
    let smartTagDashboardPageConfig = this.companyConfig ? ((this.companyConfig.appPages || {}).interactionsContactReasonPage || {}) : {};
    this.updateDataModelColumns({ columns: this.columns, columnsConfig: smartTagDashboardPageConfig.columns});

    await this.handleFilterChange({forceRefresh: true, logEvent: true});

    if(this.$refs.table) {
      this.$refs.table.finishParentRender = true;
    }
  },

  destroyed() {
    this.dataModel.keyword = '';
  }
});
</script>

<style lang="scss">
.wy-contactReasonsPage-page {
  font-family: 'Helvetica Neue', sans-serif;
  .total-topic-num{
    color: #4B5158 !important;
  }
  .wy-page-nodata-with-available-date-range {
    margin-top: 2% !important;
    background-color: #FFF !important;
  }
}
.dialogue-content-container {
  line-height: 25px;
  margin-left: 41px;
  .dialogue-content-header {
    display: inline-block;
    width: 87px;
  }
}

.wy-smart-tag-dashboard-table {
  position: relative;
  min-height: calc(100% - 20px);
  padding-right: 0px;
  margin-bottom: 10px;

  .wy-table-list .wy-table-main thead .wy-header th, .wy-table-list .wy-table-main thead .wy-sub-header th {
    background-color: #F5F8FA !important;
    color: var(--site-font-secondary-color);
    font-size: 14.5px;
    font-weight: 500;
  }
  .wy-table-list thead tr.wy-header > th:first-child, thead tr.wy-sub-header > th:first-child {
    padding-left: 13px;
  }
  .wy-table-list .wy-table-main thead .wy-sub-header th.lastChild {
    text-align: center !important;
  }
  .wy-table-list .wy-table-main thead .wy-sub-header th.lastChild.totalNegativePercent {
    text-align: right !important;
  }
  .wy-table-list .wy-table-main tbody tr td.last-child {
    text-align: center !important;
    div {
      padding-right: 0px;
    }
  }
  .wy-table-list .wy-table-main tbody tr td.totalNegativePercent.last-child {
    text-align: right !important;
    div {
      padding-right: 15px;
    }
  }
  .wy-table-list .wy-table-fixed .regular-fixed-thead-style {
    border-bottom: 1px solid #CAD2DA;
  }
  .wy-table-list .wy-table-fixed thead th:nth-last-child(1) {
    font-weight: 500;
    font-size: 14.5px;
    font-weight: bold;
    border-bottom: 0px solid transparent !important;
    // text-align: center !important;
  }
  .wy-table-list .wy-table-main thead .wy-header th span {
    font-weight: bold;
  }
  .wy-table-list .wy-table-fixed {
    th.smartTagName, th.smartTagCategory {
      text-align: left !important;
      span {
        top: -20px;
        font-size: 14px;
        position: relative;
      }
    }
    th.smartTagName::after, th.smartTagCategory::after {
      top: -14px;
    }
    tbody .fixed.last-child {
      div {
        justify-content: start !important;
      }
    }
    tbody td {
      height: 58px !important;
      // border-bottom: 0px solid #eee !important;
    }
  }
  .wy-table-list tbody tr td { 
    border-bottom: 0px solid #eee !important;
  }
  .wy-table-list .wy-table-fixed tbody td:nth-last-child(1) {
    padding-right: 10px;
    .el-edit-cancel {
      left: 0px;
    }
  }
  .wy-table-list .wy-table-main .wy-body {
    tr td { 
      border-bottom: 1px solid #eee !important;
    }
    .wy-table-tail {
      display: table-cell;
      width: inherit;
    }
  }
  .wy-table-list .wy-table-fixed tbody {
    height: calc( 100vh - 381px) !important;
    tr {
      border-bottom: 0px solid #eee !important;
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span.wy-table-content {
        color: #0B2B3B;
        font-weight: normal;
      }
    }
  }
  th.lastChild.fixed.index {
    border-bottom: 1px solid transparent;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    width: 16px;
    height: 16px;
    border: 1px solid var(--primary-checkbox-button-checked-border-color) !important;
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
  }
  span.el-checkbox__inner:hover {
    border-radius: 4px;
    font-weight: bolder;
    -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
    box-shadow: var(--primary-checkbox-button-hover-box-shadow);
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    content: '';
    position: absolute;
    display: block;
    background-color: var(--primary-checkbox-button-background-color);
    height: 2px;
    transform: scale(.5);
    left: 0;
    border: 1px solid white;
    right: 0;
    top: 6px;
  }
  .el-checkbox__inner::after {
    border: 2px solid #FFF;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    transition: transform .15s ease-in .05s;
    transform-origin: center;
  }
  .wy-sub-header{
    th.sortable::after {  // this reserves space for the up-arrow/down-arrow icon (not shown yet)
      content: "";
      display: inline-block;
      height: 15px;
      background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
      width: 15px;
      position: relative;
      top: 4px;
      left: 7px;
      background-repeat: no-repeat;
    }
  }
  th.sortable.sorted.ascending::after {
    background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
  }
  th.sortable.sorted.descending::after {
    background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
  }
  th.sortable.sorted.ascending:hover::after {
    background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
  }
  th.sortable.sorted.descending:hover::after {
    background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
  }
  th.sortable:hover {
    background-color: #E1E6EC;
    cursor: pointer;
    color: #214586;
    .sort-caret.ascending {
      background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg');
    }
    .sort-caret.descending {
      background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
    }
  }
  th.sortable:not(.sorted):hover::after {
    background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg');
  }
  th:not(.sortable) {
    span {
      padding-left: 0;
    }
  }
    
  .wy-table-list .wy-table-fixed .wy-table-content {
    width: 100%;
    font-weight: 500;
    color: #1A55AD;
    border-right: 2px solid transparent!important;
    font-family: 'Helvetica Neue', sans-serif;
    // text-decoration: underline;
  }
  .wy-table-list .wy-table-fixed .wy-table-content.edit {
    position: relative;
    left: -9px;
  }
  .wy-page-modal {
    height: 102%;
    top: -3px;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    background-color: #FFF;
    &::-webkit-scrollbar {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 3px solid transparent;
      border-top: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#FFF;
      //border-top: 1px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      // border-left: 1px solid #CAD2DA;
      border-top: none !important;
    }
  }
  .wy-table-list tbody tr td.last-child {
    border-right: 1px solid transparent;
  }
  .wy-table-list .wy-table-main tbody {
    overflow: auto;
    height: calc(100vh - 361px);
    width: calc(100% - 1px);
    max-width: 120%;
    overflow: scroll;

    tr {
      width: calc(100vw - 357px) !important;
    }
    //: unset;
    &::-webkit-scrollbar {
      width: 20px;
      height: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 180px;
      border: 5px solid transparent;
      border-top: 6px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#FFF;
      border-top: 1px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      border-left: 1px solid #CAD2DA;
      border-top: none !important;
    }
  }
  .wy-table-list .wy-table-wrapper {
    width: calc(100% - 2px) !important;
    border: 1px solid #CAD2DA;
    border-top-left-radius: unset;
    border-top-right-radius: unset;
    // border-top: unset;
    overflow: hidden;
    height: calc(100vh - 261px);
    border-radius: 8px;
  }

  // CSS styles related to svg charts generated by Chartist library from the backend
  .ct-area {
    fill-opacity: 0.5;
  }
  .ct-line {
    stroke-width: 1px;
  }
  .ct-series-a .ct-area, .ct-series-a .ct-slice-donut-solid, .ct-series-a .ct-slice-pie {
    fill: #E6E7F8;
  }
  .ct-series-a .ct-bar, .ct-series-a .ct-line, .ct-series-a .ct-point, .ct-series-a .ct-slice-donut {
    stroke: #4D50E8;
  }
  .ct-series-b .ct-area, .ct-series-b .ct-slice-donut-solid, .ct-series-b .ct-slice-pie {
    fill: #E8F1FF;
  }
  .ct-series-b .ct-bar, .ct-series-b .ct-line, .ct-series-b .ct-point, .ct-series-b .ct-slice-donut {
    stroke: #1C4DB2;
  }
  .ct-series-c .ct-area, .ct-series-c .ct-slice-donut-solid, .ct-series-c .ct-slice-pie {
    fill: none;
  }
  .ct-series-c .ct-bar, .ct-series-c .ct-line, .ct-series-c .ct-point, .ct-series-c .ct-slice-donut {
    stroke: black;
    stroke-dasharray: 3px, 3px;
    stroke-width: 0.5px;
  }
}

.line-chart-dropdown {
  box-shadow: 0px 0px 6px #55596A40 !important;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 10px;
  padding-top: 4px;
  padding-bottom: 4px;

  .el-select-dropdown__item.is-disabled {
    > span {
      opacity: 0.5;
    }
  }
}
</style>